enum SyncStatus {
    NotSynced = 1,
    Synced,
    ErrorWhileSynced
}
export default SyncStatus